import { HttpLink } from '@apollo/client'

import { REACT_APP_BACKEND_API } from 'utils/config'

export const httpLink = new HttpLink({
  uri: `${REACT_APP_BACKEND_API}/graphql`,
})
